/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { ReviewDrawer } from './ReviewDrawer';
import { useOfferReviewService } from './hooks/useOfferReviewService';
import type { ReviewPhase, ReviewConfig } from './types';

type OfferReviewDrawerProps = {
  visible: boolean;
  onClose: () => void;
  projectId: number;
  tenderId: number;
  contractId: number;
  offerId: number;
  phase: ReviewPhase;
  offerName?: string;
  isReadOnly?: boolean;
};

export const OfferReviewDrawer: React.FC<OfferReviewDrawerProps> = ({
  visible,
  onClose,
  projectId,
  tenderId,
  contractId,
  offerId,
  phase,
  offerName,
  isReadOnly = false,
}) => {
  const reviewService = useOfferReviewService(
    projectId,
    tenderId,
    contractId,
    phase
  );

  const config: ReviewConfig = {
    entityType: 'offer',
    ratingType: phase === 'screening' ? 'binary' : 'star',
    queryKeyPrefix:
      phase === 'screening'
        ? 'offer-screening-reviews'
        : 'offer-evaluation-reviews',
    isReadOnly,
    enableComments: true,
  };

  return (
    <ReviewDrawer
      visible={visible}
      onClose={onClose}
      entityId={offerId}
      entityName={offerName}
      contextIds={{ projectId, tenderId, contractId }}
      config={config}
      reviewService={reviewService}
      phase={phase}
    />
  );
};
